import { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
// Text layer for React-PDF.
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString();

const ScoresPDF = () => {
  const [numPages, setNumPages] = useState<number>();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [scale, setScale] = useState<number>(1.5);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  const goToPrevPage = () => {
    setPageNumber((prev) => Math.max(prev - 1, 1));
  };

  const goToNextPage = () => {
    setPageNumber((prev) => (numPages ? Math.min(prev + 1, numPages) : prev));
  };

  const handleZoomIn = () => {
    setScale((prev) => prev + 0.25);
  };

  const handleZoomOut = () => {
    setScale((prev) => Math.max(prev - 0.25, 0.5));
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <Document file={'/scores.pdf'} onLoadSuccess={onDocumentLoadSuccess}>
        <Page pageNumber={pageNumber} scale={scale} />
      </Document>

      <div style={{ marginTop: '1rem' }}>
        <button onClick={goToPrevPage} disabled={pageNumber <= 1}>
          ⬅
        </button>
        <span style={{ margin: '0 1rem' }}>
          Page {pageNumber} of {numPages}
        </span>
        <button onClick={goToNextPage} disabled={pageNumber >= (numPages || 0)}>
          ➡
        </button>
      </div>

      <div style={{ marginTop: '0.5rem' }}>
        <button onClick={handleZoomOut}>➖ Zoom Out</button>
        <button onClick={handleZoomIn} style={{ marginLeft: '1rem' }}>
          Zoom In ➕
        </button>
      </div>
    </div>
  );
};

export default ScoresPDF;
